var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pool-item",class:_vm.active,on:{"click":function($event){return _vm.$emit('handleItem')}}},[_c('div',{staticClass:"pool-item-inner",style:({'background-image': 'url('+ _vm.imgSrc + ')'})}),_vm._v(" "),_c('div',{staticClass:"pool-item-bg"}),_vm._v(" "),_vm._t("mark")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f772ef1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pool/item.vue
// module id = null
// module chunks = 